import { create } from 'zustand'

interface AppointmentTimeframeState {
   isCompleted: boolean
   setCompleted: (isInvited: boolean) => void
}

export const useAppointmentTimeframeStore = create<AppointmentTimeframeState>(
   (set) => ({
      isCompleted: false,
      setCompleted: (isCompleted) => set({ isCompleted }),
   })
)
